























import XButton from '@/components/atoms/Button/XButton.vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import XForm from '@/components/atoms/Form/XForm.vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import XZipInput from '@/components/atoms/Input/XZipInput.vue'
import Store from './Partial/Store.vue'
import PrefPicker from '../../PrefPicker/PrefPicker.vue'
import BaseStep from './BaseStep.vue'

type Methods = {
  initStores: () => void
  onSubmitStep: () => void
  onClickBack: () => void
}

export default BaseStep.extend<{}, Methods, {}, {}>({
  name: 'StepTwo',
  components: {
    XButton,
    XCard,
    XForm,
    XFormLabel,
    XZipInput,
    PrefPicker,
    XInput,
    Store,
  },
  methods: {
    initStores() {
      this.input.storeApplications = Array.from(
        new Array(this.input.storeCount),
        () => ({
          name: '',
          zipCode: '',
          prefId: 0,
          address1: '',
          address2: '',
          phone: '',
          siteUrl: '',
          industryId: '',
          industryFreeWord: '',
        })
      )
    },
    onSubmitStep() {
      this.onNext('step3')
    },
    onClickBack() {
      this.onNext('step1')
    },
  },
  mounted() {
    const size = this.input.storeApplications?.length
    if (!size) {
      this.initStores()
    } else if (size !== this.input.storeCount) {
      // FIXME 店舗数を変更した場合
      this.initStores()
    }
  },
})
